<template>
    <v-container id="home-container" class="" fluid fill-height>
        <HomeMainCarousel></HomeMainCarousel>
        <HomeTopActivities></HomeTopActivities>
        <HomeSubCarousel></HomeSubCarousel>
        <div id="carousel-shadow">
            <img id="carousel-logo" src="../assets/logo.png">
        </div>
    </v-container>
</template>

<script>
import HomeMainCarousel from '@/components/ui/HomeMainCarousel.vue';
import HomeTopActivities from '@/components/layout/HomeTopActivities.vue';
import HomeSubCarousel from '@/components/ui/HomeSubCarousel.vue';

export default {
    name: 'Home',
    components: {
        HomeMainCarousel,
        HomeTopActivities,
        HomeSubCarousel
    }
};
</script>

<style scoped>
#carousel-logo {
    /* position: absolute;
    top: 300px;
    left: 50%; */
    position:relative;
    max-width:100%;
    max-height:100%;
    margin-top:-12%;
    margin-left:-50%;
    background-color: rgba(255,255,255, 0.75);
}
#carousel-shadow {
    position:absolute;
    max-width:45%;
    max-height:45%;
    top:400px;
    left:50%;
    overflow:visible;
}



</style>
